module.exports = __webpack_public_path__ + "static/img/15.e792cf9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/zh/15.png
// module id = dQ2u
// module chunks = 0